// src/stores/langStore.js
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLangStore = defineStore('lang', () => {
  const currentLanguage = ref('fr')

  const setLanguage = (lang) => {
    currentLanguage.value = lang
  }

  const getLocalizedText = (textObject) => {
    if (!textObject) return ''
    return textObject[currentLanguage.value] || textObject.fr || textObject.en || ''
  }

  return { currentLanguage, setLanguage, getLocalizedText }
})